













import Vue from 'vue'
import { Component, Prop, Watch, Emit } from 'vue-property-decorator'

import { Property } from '@/modules/Property/interfaces/property'
import { dateTimeToDisplay, dateToDisplay } from '@/utils/dateTime'
import AppDialog from '@/components/AppDialog.vue'
import FoldingCard from '@/components/FoldingCard.vue'
import AppSystemInfoCard from '@/components/AppSystemInfoCard.vue'
import { RecordType, RecordTypeAdditionalInfo, RecordTypeFormItem } from '@/modules/RecordType/interfaces/record-type'

@Component({
  components: {
    FoldingCard,
    AppDialog,
    AppSystemInfoCard
  }
})
export default class PropertyDetailDetail extends Vue {
  @Prop({ type: Object as () => Property }) readonly property!: Property
  @Prop({ type: Object as () => RecordType }) readonly recordType!: RecordType

  dateTimeToDisplay = dateTimeToDisplay
  dateToDisplay = dateToDisplay

  policyInfoCard: {
    title: string;
    content: string;
  }[] = []

  otherInfoCard = [
    { title: 'Mortgagee', content: '-' },
    { title: 'Current Coverage', content: '-' },
    { title: 'Loan Number', content: '-' },
    { title: 'Notes', content: '-' }
  ]

  additionalInfoCards: {
    title: string;
    items: {[key: string]: string;}[]
  }[] = []

  get policyRoute () {
    return {
      name: 'PolicyDetailDetail',
      params: {
        id: this.property.policy.id
      }
    }
  }

  get quoteRoute () {
    return {
      name: 'QuoteDetailDetail',
      params: {
        id: this.property.quote.id
      }
    }
  }

  mounted () {
    this.onPropertyUpdated(this.property)
  }

  @Watch('property', { deep: true })
  onPropertyUpdated (val: Property) {
    this.otherInfoCard[0].content = val.lienHolder
      ? val.lienHolder.name
      : '-'

    this.otherInfoCard[1].content = val.currentCoverage || '-'

    this.otherInfoCard[2].content = val.loanNumber || '-'

    this.otherInfoCard[3].content = val.notes || '-'
    this.udpateAddtionalInfo(val.additionalInfoStr)
  }

  udpateAddtionalInfo (val: string) {
    const additionalInfo = JSON.parse(val)
    const recordTypeAddionalInfo = this.recordType.additionalInfo
    this.additionalInfoCards = []

    recordTypeAddionalInfo.map((info: RecordTypeAdditionalInfo) => {
      const { items, title } = info
      const _items = items.map((item: RecordTypeFormItem) => {
        return {
          title: item.name,
          content: additionalInfo[item.keyName] || '-'
        }
      })
      this.additionalInfoCards.push({
        title: title,
        items: _items
      })
    })
  }
}
